import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { alignSelf, backgroundColor, border, borderRadius, display, space } from 'styled-system';

import { cursor } from '../../theme/system-utilities';

const UnstyledIconButton = styled.button<any>`
  ${alignSelf};
  ${backgroundColor};
  ${border};
  ${display};
  ${space};
  ${cursor};
  ${borderRadius};
`;

const IconButton = (props: ComponentProps<typeof UnstyledIconButton>) => (
  <UnstyledIconButton
    backgroundColor="transparent"
    border="none"
    display="flex"
    m="sp_0"
    ml={['sp_12', 'sp_8', 'sp_12']}
    p="sp_0"
    type="button"
    cursor="pointer"
    borderRadius="medium"
    {...props}
  />
);

export default IconButton;
